import { Body5RegularTypography } from "../../primitives/Typography/typographyVariants";
import { PillProps } from "./Pill.types";
import {
  CloseIconWrapper,
  ImageWrapper,
  PillContent,
  PillWrapper,
  StyledIcon,
} from "./Pill.styles";
import { colorPalette } from "../../theme/colors";

export const Pill = ({
  name,
  iconUrl,
  selected,
  onClick,
  containImage,
  variant = "default",
  onClickCross,
  dataCy,
}: PillProps) => {
  const handleClickCross = (e: React.MouseEvent) => {
    e.stopPropagation(); // Stop event propagation to prevent input field click

    if (onClickCross) {
      onClickCross(); // Execute the external function if it's provided
      return; // Exit the function early, preventing any further logic
    }
  };
  return (
    <>
      <PillWrapper
        selected={selected}
        onClick={onClick}
        variant={variant}
        data-cy={dataCy}
      >
        {iconUrl && (
          <ImageWrapper containImage={containImage}>
            <img src={iconUrl} alt={name} />
          </ImageWrapper>
        )}
        <PillContent>
          <Body5RegularTypography
            color={
              variant !== "default" && selected
                ? colorPalette.popWhite[500]
                : colorPalette.popBlack[500]
            }
          >
            {name}
          </Body5RegularTypography>
          {variant === "tag" && selected && (
            <CloseIconWrapper onClick={handleClickCross}>
              <StyledIcon className="fa-solid fa-xmark" />
            </CloseIconWrapper>
          )}
        </PillContent>
      </PillWrapper>
    </>
  );
};
